import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CaseStudy from '../../../micro/caseStudy/CaseStudy';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';
import LearningCheckQuestions from '../../../micro/learningCheck/LearningCheckQuestions';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  header: {
    width: '60%',
    paddingBottom: 40,
  },
}));

type InterpretationPage10Props = {
  setNextDisabledCS: (disabled: boolean) => void;
  setNextDisabled: (disabled: boolean) => void;
};

const InterpretationPage10 = ({ setNextDisabledCS, setNextDisabled }: InterpretationPage10Props): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.grayBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[1].INTERPRETATION_STEP_1.path}`}
          alt={`${IMAGE_PATHS.STEPS[1].INTERPRETATION_STEP_1.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 1:</Typography>
          <Typography variant="h3" className={classes.header}>
            Review General Interpretation Criteria and Read Methodology (continued)
          </Typography>
          <CaseStudy trainingId={1} module="axuminInterpretation" page={10} setNextDisabledCS={setNextDisabledCS} />
        </div>
      </div>
      <LearningCheckQuestions
        module="axuminInterpretation"
        page={10}
        setNextDisabled={setNextDisabled}
        trainingId={1}
      />
    </>
  );
};

export default InterpretationPage10;
